module.exports = __webpack_public_path__ + "static/media/duplicate.bca1e2f2.svg";